import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from './lan/zn'
import en from './lan/en'

Vue.use(VueI18n); // 全局挂载
const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "zh", // 从localStorage中获取 默认中文
  messages:{
    zh,
    en
  }
});
export default i18n;
